import React from 'react';

import instapayLogo from './../../../../../../../statics/img/instapay/instapay_logo.jpeg';

function RequestPayModal() {
  return (
    <div className="instapay_modal">
      <div className="instapay_modal_header">
        <div className="instapay_request">
          <div className="instapay_request_header">
            <img
              src={instapayLogo}
              alt="instapay"
              className="instapay_request_header_logo"
            />
            <div className="instapay_request_header_support">
              <p className="instapay_request_header_support-light-text instapay_mb-2">
                You are being redirected to the Instapay app to complete
                payment 
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestPayModal;
